"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconPadlockUnlocked = function SvgIconPadlockUnlocked(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "padlock unlocked icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Padlock Unlocked Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.815 43.435H35.55V21.764H11.815v21.67zm25.799-25.799H15.427v-3.55c0-5.283 3.333-8.833 8.178-8.833 3.529 0 6.282 1.83 7.485 5.02a2.086 2.086 0 002.68 1.202 2.069 2.069 0 001.212-2.659C33.166 4 28.865 1.125 23.6 1.125c-7.2 0-12.3 5.33-12.3 12.961v3.55H9.75a2.07 2.07 0 00-2.063 2.072v25.79c0 1.14.924 2.064 2.063 2.064h27.863c1.14 0 2.064-.924 2.064-2.064v-25.79a2.07 2.07 0 00-2.064-2.072z"
  }));
};

var _default = SvgIconPadlockUnlocked;
exports.default = _default;